// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarButton_root__zoMUY","button":"NavbarButton_button__okCG0","text":"NavbarButton_text__7gtaV"};